var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6194 0.572266H3.33371C1.75847 0.572266 0.476562 1.85417 0.476562 3.42941V20.5723C0.476562 22.1475 1.75847 23.4294 3.33371 23.4294V21.5247C2.80799 21.5247 2.38133 21.098 2.38133 20.5723C2.38133 20.0466 2.80799 19.6199 3.33371 19.6199H5.23847V23.4294L7.61942 21.0485L10.0004 23.4294V19.6199H17.6194V21.5247H11.9051V23.4294H19.5242V2.47703C19.5242 1.42655 18.6699 0.572266 17.6194 0.572266ZM2.38133 17.8789V3.42941C2.38133 2.9037 2.80799 2.47703 3.33371 2.47703H4.28609V17.7151H3.33371C2.99942 17.7151 2.67942 17.7732 2.38133 17.8789ZM6.19085 17.7151V2.47703H17.6194V17.7151H6.19085Z",
    fill: "#F1F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingsIcon);
export default __webpack_public_path__ + "static/media/trainings-icon.887e721407cb515a2faa73286a7a19bf.svg";
export { ForwardRef as ReactComponent };